import React, {Component} from 'react';
import {connect} from 'react-redux'
import {
    changeElementsPerRow,
    imageError,
    imageLoaded,
    resetReady,
} from '../actions/actionsAnimalList';
import {browserHistory} from 'react-router';
import Pagination from '../../Shared/components/components/Pagination/Pagination';
import {PATH_ADOPTAR, PATH_ADOPTAR_ID, PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID} from "../../../App/RouterAdopta";
import AnimalList from "./AnimalList";
import {LazyLoadImage} from "react-lazy-load-image-component";
import CardInfoRaza from "././CardInfoRazas/CardInfoRaza";


let ELEMENS_PER_ROW = 2;

class AnimalListContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showAnimalPreview: false,
            idAnimalPreview: 0,
            indexSelected: undefined,
            imageLoadedArray: []
        }


        this.onClickCard = this.onClickCard.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.handleHidePreview = this.handleHidePreview.bind(this);
        this.onClickPagination = this.onClickPagination.bind(this);
    }


    onClickCard(e) {
        this.handleHidePreview();

        let index = $(e.currentTarget).data('index');
        let indexRow = $(e.currentTarget).data('indexrow');
        let id = $(e.currentTarget).data('id');

        browserHistory.push(PATH_ADOPTAR_ID + id);


        this.setState({
            ...this.state,
            indexSelected: index
        })

        // this.props.showAnimalDetail(true, index, indexRow, id, this.props.animalsControl);
    }

    handleModify(idAnimal) {
        browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ANIMAL_ID + idAnimal);
    }

    handleHide() {
        this.setState({
            ...this.state,
            indexSelected: undefined
        });
    }

    handleHidePreview() {
        // console.log("no se que es esto")
        const {animalIdParam} = this.props;
        if (animalIdParam) {
            this.setState({
                idAnimalPreview: animalIdParam,
                showAnimalPreview: false,
                indexSelected: undefined
            });
        }

        if (this.props.animalsControl === "animals") {
            browserHistory.push(PATH_ADOPTAR);
        }
    }


    renderAnimalList() {
        const elementsPerRow = this.props.elementsPerRow;
        let classReady = "";
        let isReady = this.props.isReady;
        if (isReady) {
            classReady = "listing-houses__item-image";
        } else {
            //Caso en que estén cacheadas...
            if (this.props.imagesLoaded === 0) {
                classReady = "listing-houses__item-image";
                isReady = true;
            } else {
                classReady = "listing-houses__item-image image_holder";
            }
        }


        const that = this;
        if (this.props.list && this.props.list.length !== 0 && isReady) {
            return (
                <AnimalList
                    list={this.props.list}
                    isReady={true}
                    totalRecord={this.props.totalRecord}
                    pag={this.props.pag}
                    elementsPerRow={this.props.elementsPerRow}
                    elementsPerPage={this.props.elementsPerPage}
                    animalsControl={this.props.animalsControl}
                    animalsControlDetail={this.props.animalsControlDetail}
                    isAdminAnimals={this.props.isAdminAnimals}
                    access={this.props.access}
                />)
        } else {

            return (
                <div id="not-found-container" className="">
                    <div>

                        {this.props.access && this.props.access.isLogin &&
                            this.props.isAdminAnimals &&
                            this.props.animalsControlDetail === "animalDetailProtectora" &&
                            <h1 className="not-found-animal-head animated-500ms fadeInDown">Ups! No tienes animales con
                                esas
                                características</h1>}

                        {!this.props.isAdminAnimals &&
                            this.props.animalsControlDetail === "animalDetailProtectora" &&
                            <h1 className="not-found-animal-head animated-500ms fadeInDown">Ups! {(this.props.infoProtectoraDetail && this.props.infoProtectoraDetail.nombre) ? this.props.infoProtectoraDetail.nombre : "Esta protectora"} no
                                tiene animales con esas
                                características</h1>}

                        {this.props.animalsControlDetail === "animalDetail" &&
                            <h1 className="not-found-animal-head animated-500ms fadeInDown">Ups! No tenemos animales con
                                esas
                                características</h1>}

                        <div className="not-found-animal-description animated-500ms fadeInDown">Modifica los filtros
                            para
                            encontrar lo que buscas
                        </div>

                    </div>
                    <div>
                        <LazyLoadImage
                            className="image-not-found-animals animated-500ms fadeIn"
                            src={process.env.CDN_URL + '/images/adoptaunanimal/animals/cat-gray.gif'}
                            threshold={150} alt="image-not-found-animals" width="1080" height="785"/>
                    </div>
                </div>)

        }

    }

    onClickPagination(num) {
        if (this.props.pag !== num) {
            //Up to top of page.
            //console.log("Haciendo scrollTop paginado");
            // let element = $('#animals-list-container')[0];
            //if (element.length !== 0) {
            $('body,html').stop(true, true).animate({scrollTop: 0}, 200);
            // }

            $('#div-space-buttom').show();
            $('#animals-list-container').css('visibility', 'hidden');
            //$('#animals-list-container').hide();

            // $('#loaderImage').removeClass('fadeOut').addClass('animated-400ms fadeIn');
            $('#loaderImage').show();
            this.handleHidePreview();
            this.setState({
                indexSelected: undefined
            });
            this.props.loadAnimals(num);
        }
    }

    render() {
        // console.log("AnimalListContainer::render()");
        const {animalIdParam} = this.props;
        //En el caso de que el resto no sea 0 se añade una paginación más.
        let numPags = 0;
        if (this.props.elementsPerPage !== 0) {
            numPags = Math.trunc(this.props.totalRecord / this.props.elementsPerPage);
            if (this.props.totalRecord % this.props.elementsPerPage !== 0) {
                numPags++;
            }
        }
        const infoRaza = this.props.infoRaza
        return (
            <div className="listing-houses">
                {this.renderAnimalList()}
                <CardInfoRaza infoRaza={infoRaza} onClickCard={this.onClickCard}/>
                <nav className="listings-pagination d-flex justify-content-center">
                    {numPags > 0 && (
                        <Pagination
                            pageCount={numPags}
                            onClickPagination={this.onClickPagination}
                        />
                    )}
                </nav>
            </div>
        );
    }

    componentWillMount() {
        $('#not-found-container').hide()
        $('#div-space-buttom').show();


        const {animalIdParam} = this.props;
        if (animalIdParam) {
            this.setState({
                ...this.state,
                idAnimalPreview: animalIdParam,
                showAnimalPreview: true
            });
        }
        this.props.resetReady(this.props.animalsControl);
    }

    componentDidMount() {
        $('#not-found-container').hide()

        // const animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        const that = this;

        $(window).on('resize', function () {
            const width = window.innerWidth;
            if (width < 992 && ELEMENS_PER_ROW !== 1) {
                ELEMENS_PER_ROW = 2;
                that.props.changeElementsPerRow(ELEMENS_PER_ROW, that.props.animalsControl)
            } else if (width >= 992 && ELEMENS_PER_ROW !== 3) {
                ELEMENS_PER_ROW = 3;
                that.props.changeElementsPerRow(3, that.props.animalsControl)
            }
        });
        // const img = this.image.current;
        // if (img && img.complete) {
        //     this.handleImageLoaded();
        // }
        // $('#loaderImage').addClass('animated-400ms fadeOut').one(animationEnd, function () {
        const element_go = $("body");
        if (element_go.length !== 0) {
            //console.log("AnimalListContainer::componentDidMount() -> Haciendo scrollTop");
            $('body,html').stop(true, true).animate({scrollTop: element_go.offset().top}, 0);
        }
        // $('#animals-list-container').removeClass("fadeOut").addClass('animated-0s fadeIn');

        $('#animals-list-container').css('visibility', 'visible');
        //$('#animals-list-container').show();
        $('#div-space-buttom').hide();

        // $('#loaderImage').removeClass("fadeIn");
        $('#loaderImage').hide();

        if (!that.props.showFooter) {
            // $('.footer-default').addClass('animated-400ms fadeInUp');
            $('.footer-default').show();
        } else {
            // $('.footer-default').removeClass('animated-400ms fadeInUp');
            $('.footer-default').show();
        }
        // });
    }


    componentDidUpdate(prevProps, prevState, prevContext) {
        const {isReady} = this.props

        if (isReady || this.props.imagesLoaded === 0) {
            // const animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

            // let that = this;
            $('#loaderImage').hide();
            // $('#loaderImage').addClass('animated-400ms fadeOut').one(animationEnd, function () {
            //     $('#animals-list-container').removeClass("fadeOut").addClass('animated-0s fadeIn').one(animationEnd, function () {
            // var nav = $('.cardAnimalDetail');

            // var animateTime = 0;
            // that.autoHeightAnimate(nav, animateTime);
            // });

            $('#animals-list-container').css('visibility', 'visible');
            // $('#animals-list-container').show();

            // $('#div-space-buttom').addClass('animated-400ms fadeOut').one(animationEnd, function () {
            $('#div-space-buttom').hide()
            // });
            // $('#loaderImage').removeClass("fadeIn");
            // $('#loaderImage').hide();

            // });


        }
        if (!this.props.list || this.props.list.length === 0 && this.props.imagesLoaded === 0) {
            $('#not-found-container').show()
        } else {
            $('#not-found-container').hide()
        }
    }

    // autoHeightAnimate(element, time) {
    //     console.log("AnimalListContainer::autoHeightAnimate()");
    //     var curHeight = element.outerHeight(true); // Get Default Height
    //     var autoHeight = element.css('height', 'auto').outerHeight(true); // Get Auto Height
    //     element.height(curHeight); // Reset to Default Height
    //     element.stop().animate({height: autoHeight}, time);
    // }
}

function mapStateToProps(state, ownProps) {
    return {
        infoProtectoraDetail: state[ownProps.animalsControlDetail].infoProtectoraDetail,
        isReady: state[ownProps.animalsControl].isReady,
        imagesLoaded: state[ownProps.animalsControl].imagesLoaded,
        showFooter: state.structureControl.showFooter,
        imageLoadedArray: [],
        access: state.access
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {
    changeElementsPerRow,
    resetReady,
    imageError,
    imageLoaded,
})(AnimalListContainer)
